// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ArtRouteImport } from './routes/art'
import { Route as ClassesRouteImport } from './routes/classes'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DirectionsRouteImport } from './routes/directions'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as OurStoryRouteImport } from './routes/our-story'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ServicesRouteImport } from './routes/services'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ArtRoute = ArtRouteImport.update({
            id: '/art',path: '/art',getParentRoute: () => rootRouteImport
          })
const ClassesRoute = ClassesRouteImport.update({
            id: '/classes',path: '/classes',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DirectionsRoute = DirectionsRouteImport.update({
            id: '/directions',path: '/directions',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const OurStoryRoute = OurStoryRouteImport.update({
            id: '/our-story',path: '/our-story',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ArtRoute: ArtRoute,ClassesRoute: ClassesRoute,ContactRoute: ContactRoute,DirectionsRoute: DirectionsRoute,FaqRoute: FaqRoute,GalleryRoute: GalleryRoute,OurStoryRoute: OurStoryRoute,ReviewsRoute: ReviewsRoute,ServicesRoute: ServicesRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)